export interface Client {
  uid: string;
  companyId: number;

  firstName: string | null;
  lastName: string | null;
  alias: string | null;
  avatar: string | null;
  clientCompanyName: string | null;
  type: "commercial" | "residential" | string;
  /** Iowa only. True when the occupant pays. Null means not answered. */
  occupantPays?: boolean | null;

  email: string | null;
  phone: string | null;
  dialCode: string | null;
  countryCode: string | null;

  address: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  country: string | null;

  userUid: string | null;

  isDeleted: boolean | null;
  createdAt: string;
  updatedAt: string;

  coverageAreas: any[];
}

export interface IClientImportRow {
  firstName: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  clientCompanyName?: string;
  type?: string;
  status?: string;
}

export interface IBulkImportClientsPayload {
  clients: IClientImportRow[];
}

export interface IBulkImportClientError {
  rowIndex: number;
  field?: keyof IClientImportRow;
  message: string;
}

export interface IBulkImportClientsResponse {
  success: boolean;
  importedCount: number;
  failedCount: number;
  errors?: IBulkImportClientError[];
}

export enum EClientStatus {
  PROSPECT = "PROSPECT",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
